export default __webpack_public_path__ + "static/real4-5650fb9eea3d555c43e196642c055124.png";